import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { Top5Service } from "./shared/data.service";
import { Observable, timer } from "rxjs";
import { SchoolService } from "../../../shared/services/school.service";

@Component({
	selector: "app-top5-dialog",
	templateUrl: "./top5-dialog.component.html",
	styleUrls: ["./top5-dialog.component.css"],
})
export class Top5DialogComponent implements OnInit {
	constructor(
		private userService: UserService,
		private top5Service: Top5Service,
		private ref: DynamicDialogRef,
		private router: Router,
		private selectService: SchoolselectorService,
		private schoolService: SchoolService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});

		//
		// Wait a couple of seconds, if the School Selector didn't do anything
		//
		this.NoSchoolWaitTimer = timer(this.NoSchoolWaitSeconds * 1000, this.NoSchoolWaitSeconds * 1000);
		this.NoSchoolWaitSubscription = this.NoSchoolWaitTimer.subscribe((val) => {
			if (this.ManuallySearched == false && this.SchoolFound == false) {
				this.ManuallySearched = true;
				this.loadSchoolManually();
			}
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
		this.NoSchoolWaitSubscription.unsubscribe();
		this.NoSchoolWaitTimer = null;
	}

	////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////
	user: any;
	subscription: any;

	RawData: any;

	SchoolFound: boolean = false;
	SchoolFullName: string = "...Loading";

	ManuallySearched: boolean = false;
	NoSchoolWaitSeconds: number = 5;
	NoSchoolWaitTimer: any;
	NoSchoolWaitSubscription: any;

	SemesterStatusID: number = -1;
	SchoolDayStatusID: number = -1;
	CalendarStatusID: number = -1;
	PeriodStatusID: number = -1;
	TardyTimeStatusID: number = -1;

	// lstWarningCalendar: any = [];
	// lstWarningSchoolDay: any = [];
	// lstWarningSemester: any = [];
	// lstWarningPeriod: any = [];
	// lstWarningTardyTime: any = [];
	// lstErrorCalendar: any = [];
	// lstErrorSchoolDay: any = [];
	// lstErrorSemester: any = [];
	// lstErrorPeriod: any = [];
	// lstErrorTardyTime: any = [];

	SemesterMessage: string = "";
	SchoolDayMessage: string = "";
	CalendarMessage: string = "";
	PeriodMessage: string = "";
	TardyTimeMessage: string = "";

	CanAccessSemester: boolean = false;
	CanAccessSchoolDay: boolean = false;
	CanAccessCalendar: boolean = false;
	CanAccessPeriod: boolean = false;
	CanAccessTardyTime: boolean = false;

	loading: boolean = true;
	LoadingText: string = "...loading";

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////

	loadTop5(SchoolID) {
		if (SchoolID == undefined || SchoolID <= 0) {
			return;
		}

		this.loading = true;

		var result = this.top5Service.Top5SelectInfo(this.user.userID, SchoolID);
		result.subscribe(
			(response: any) => {
				// console.log(response);

				this.CanAccessSemester = response.CanAccessSemester;
				this.CanAccessSchoolDay = response.CanAccessSchoolDay;
				this.CanAccessCalendar = response.CanAccessCalendar;
				this.CanAccessPeriod = response.CanAccessPeriod;
				this.CanAccessTardyTime = response.CanAccessTardyTime;

				//
				//#region  Single School
				//
				this.SemesterStatusID = response.SemesterWarningLevel;
				this.SchoolDayStatusID = response.SchoolDayWarningLevel;
				this.CalendarStatusID = response.CalendarWarningLevel;
				this.PeriodStatusID = response.PeriodWarningLevel;
				this.TardyTimeStatusID = response.TardyTimeWarningLevel;

				this.SemesterMessage = response.SemesterWarningMessage;
				this.SchoolDayMessage = response.SchoolDayWarningMessage;
				this.CalendarMessage = response.CalendarWarningMessage;
				this.PeriodMessage = response.PeriodWarningMessage;
				this.TardyTimeMessage = response.TardyTimeWarningMessage;
				//
				//#endregion
				//

				//
				//#region Multiple Schools
				//

				// this.lstWarningCalendar = response.lstWarningCalendar;
				// this.lstWarningSchoolDay = response.lstWarningSchoolDay;
				// this.lstWarningSemester = response.lstWarningSemester;
				// this.lstWarningPeriod = response.lstWarningPeriod;
				// this.lstWarningTardyTime = response.lstWarningTardyTime;
				// this.lstErrorCalendar = response.lstErrorCalendar;
				// this.lstErrorSchoolDay = response.lstErrorSchoolDay;
				// this.lstErrorSemester = response.lstErrorSemester;
				// this.lstErrorPeriod = response.lstErrorPeriod;
				// this.lstErrorTardyTime = response.lstErrorTardyTime;

				//
				// Check Status (Which icon to display)
				//

				//
				//#region Calendar
				//
				// if(this.lstWarningCalendar.length == 0 && this.lstErrorCalendar.length == 0){
				//   this.CalendarStatusID = 0;
				//   this.CalendarMessage = "Calendars valid for all of your schools";
				// }
				// else if(this.lstErrorCalendar.length > 0){
				//   this.CalendarStatusID = 2;
				//   this.CalendarMessage = this.lstErrorCalendar[0].WarningMessage;
				// }
				// else if(this.lstErrorCalendar.length == 0 && this.lstWarningCalendar.length > 0){
				//   this.CalendarStatusID = 1;
				//   this.CalendarMessage = this.lstWarningCalendar[0].WarningMessage;
				// }
				//#endregion
				//

				//
				//#region School Day
				//
				// if(this.lstWarningSchoolDay.length == 0 && this.lstErrorSchoolDay.length == 0){
				//   this.SchoolDayStatusID = 0;
				//   this.SchoolDayMessage = "School Days valid for all of your schools";
				// }
				// else if(this.lstErrorSchoolDay.length > 0){
				//   this.SchoolDayStatusID = 2;
				//   this.SchoolDayMessage = this.lstErrorSchoolDay[0].WarningMessage;
				// }
				// else if(this.lstErrorSchoolDay.length == 0 && this.lstWarningSchoolDay.length > 0){
				//   this.SchoolDayStatusID = 1;
				//   this.SchoolDayMessage = this.lstWarningSchoolDay[0].WarningMessage;
				// }
				//#endregion
				//

				//
				//#region Semester
				//
				// if(this.lstWarningSemester.length == 0 && this.lstErrorSemester.length == 0){
				//   this.SemesterStatusID = 0;
				//   this.SemesterMessage = "Semesters valid for all of your schools";
				// }
				// else if(this.lstErrorSemester.length > 0){
				//   this.SemesterStatusID = 2;
				//   this.SemesterMessage = this.lstErrorSemester[0].WarningMessage;
				// }
				// else if(this.lstErrorSemester.length == 0 && this.lstWarningSemester.length > 0){
				//   this.SemesterStatusID = 1;
				//   this.SemesterMessage = this.lstWarningSemester[0].WarningMessage;
				// }
				//#endregion
				//

				//
				//#region Period
				//
				// if(this.lstWarningPeriod.length == 0 && this.lstErrorPeriod.length == 0){
				//   this.PeriodStatusID = 0;
				//   this.PeriodMessage = "Periods valid for all of your schools";
				// }
				// else if(this.lstErrorPeriod.length > 0){
				//   this.PeriodStatusID = 2;
				//   this.PeriodMessage = this.lstErrorPeriod[0].WarningMessage;
				// }
				// else if(this.lstErrorPeriod.length == 0 && this.lstWarningPeriod.length > 0){
				//   this.PeriodStatusID = 1;
				//   this.PeriodMessage = this.lstWarningPeriod[0].WarningMessage;
				// }
				//#endregion
				//

				//
				//#region TardyTime
				//
				// if(this.lstWarningTardyTime.length == 0 && this.lstErrorTardyTime.length == 0){
				//   this.TardyTimeStatusID = 0;
				//   this.TardyTimeMessage = "Tardy Times valid for all of your schools";
				// }
				// else if(this.lstErrorTardyTime.length > 0){
				//   this.TardyTimeStatusID = 2;
				//   this.TardyTimeMessage = this.lstErrorTardyTime[0].WarningMessage;
				// }
				// else if(this.lstErrorTardyTime.length == 0 && this.lstWarningTardyTime.length > 0){
				//   this.TardyTimeStatusID = 1;
				//   this.TardyTimeMessage = this.lstWarningTardyTime[0].WarningMessage;
				// }
				//#endregion
				//

				//
				//#endregion
				//

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	loadSchoolManually() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response: any) => {
				var lstSchool = response;

				this.onSchoolChange(lstSchool[0]);

				//
				// Stop Timer
				//
				this.NoSchoolWaitSubscription.unsubscribe();
				this.NoSchoolWaitTimer = null;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////
	onViewSemester() {
		this.router.navigate(["/adminsettings/semester"]);
		this.onClose();
	}

	onViewSchoolDay() {
		this.router.navigate(["/adminsetup/schoolday"]);
		this.onClose();
	}

	onViewCalendar() {
		this.router.navigate(["/adminsetup/calendar"]);
		this.onClose();
	}

	onViewPeriod() {
		this.router.navigate(["/adminsettings/period"]);
		this.onClose();
	}

	onViewTardyTime() {
		this.router.navigate(["/adminsettings/tardy"]);
		this.onClose();
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////////////////

	onSchoolChange(school) {
		// this.SchoolID = school.SchoolID;
		if (school != undefined && school.SchoolID != undefined && school.SchoolID > 0) {
			this.SchoolFound = true;
			this.SchoolFullName = school.SchoolNumber + " - " + school.SchoolName;
			this.loadTop5(school.SchoolID);
		}
	}

	////////////////////////////////////////////////////////////////////////
}
